// src/components/ui/ThreadBanner.tsx
import { brand, fonts } from '@/lib/tokens';

type Props = {
  /** Booking ID of the thread root, e.g. "#2847-LF" */
  threadRootId: string;
  /** Click handler to navigate to the original booking. */
  onOpenRoot?: () => void;
};

export function ThreadBanner({ threadRootId, onOpenRoot }: Props) {
  return (
    <div
      role="status"
      className="flex items-center gap-3 w-full"
      style={{
        padding: '12px 18px',
        borderRadius: 10,
        background: brand.warningTint,
        border: `1px solid rgba(251,146,60,0.28)`,
        color: brand.warning,
      }}
    >
      <WarningIcon />
      <p
        className="flex-1"
        style={{ color: 'rgba(var(--fg-rgb),0.85)', fontSize: 13, lineHeight: 1.45 }}
      >
        <span style={{ color: brand.warning, fontWeight: 600 }}>Thread Reply</span>
        <span style={{ color: 'rgba(var(--fg-rgb),0.45)' }}> — </span>
        This email is part of existing approved booking{' '}
        <button
          onClick={onOpenRoot}
          style={{
            background: 'transparent',
            border: 'none',
            fontFamily: fonts.mono,
            color: brand.onSurface,
            cursor: 'pointer',
            padding: 0,
            textDecoration: 'underline',
            textDecorationColor: 'rgba(var(--fg-rgb),0.25)',
            textUnderlineOffset: '3px',
          }}
        >
          {threadRootId}
        </button>
        . It has not entered the workflow.
      </p>
    </div>
  );
}

function WarningIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    </svg>
  );
}
